import { render, staticRenderFns } from "./DemoForm.vue?vue&type=template&id=cf1df654&scoped=true"
import script from "./DemoForm.vue?vue&type=script&lang=js"
export * from "./DemoForm.vue?vue&type=script&lang=js"
import style0 from "./DemoForm.vue?vue&type=style&index=0&id=cf1df654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1df654",
  null
  
)

export default component.exports